import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import milestoneTypes from '../consts/loyalty/milestoneTypes';
import loyaltyService from '../services/loyalty/loyaltyService';
import {selectIsPWA} from '../state/selectors/global';

const useCompleteFirstMilestone = () => {
    const isPWA = useSelector(selectIsPWA);

    const completeFirstMilestone = async () => {
        await loyaltyService.completeMilestone(milestoneTypes.ADD_APP_TO_HOME_SCREEN, true);
    };

    useEffect(() => {
        if (isPWA) {
            completeFirstMilestone();
        }
    }, [isPWA]);
};

export default useCompleteFirstMilestone;
